<div class="col-auto my-2 has-validation">
  @if (label(); as label) {
    <label
      class="form-label"
      [class.required]="hasRequiredValidator()"
      for="{{ inputFormControlName() }}"
    >
      {{ label | translate }}
    </label>
  }
  <input
    class="form-control"
    type="text"
    id="{{ inputFormControlName() }}"
    [currencyMask]="currencyMask()"
    [formControl]="inputFormControl()"
    [attr.required]="hasRequiredValidator()"
    (keydown.enter)="omitKeydownEnter() ? onEnterKey($event) : null"
  />

  @if (inputFormControl().touched && inputFormControl().invalid) {
    <div class="feedback">
      <div *ngIf="errorKeys().length > 0">
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      </div>
    </div>
  } @else if (leaveSpaceForValidation() || feedback()) {
    <div class="placeholder-feedback">
      @if (feedback(); as feedback) {
        {{ feedback | translate }}
      }
    </div>
  }
</div>
